import axios from "axios"
import qs from 'qs';
import ApiStore from "./ApiStore";
var querystring = require('querystring');


export class WorkdocStore extends ApiStore{
  constructor() {
    super();
  }

  loadDocRecord(workNo,docType,completeFunc,errorFunc){
    axios.get('/workdoc/docrecord/'+docType+'?wo='+workNo)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc(error)
    })
  }

  loadProgram(completeFunc, errorFunc) {
    axios.get('/workdoc/programlist/')
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }


  loadConfigFixingList(completeFunc, errorFunc) {
    axios.get('/workdoc/config_fixinglist')
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }

  saveConfigFixingList(postData,completeFunc,errorFunc) {
    console.log('postData',postData)
    axios.post('/workdoc/config_fixinglist',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })  
  } 

  loadProvince(completeFunc, errorFunc) {
    axios.get('/workdoc/provincelist')
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }

  loadTitle(completeFunc, errorFunc) {
    axios.get('/workdoc/autocomplete/title')
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }

  loadWorkdocCarInfo(wo,completeFunc, errorFunc) {
    axios.get('/workdoc/car_info/?wo='+wo)
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }


  loadCarType(completeFunc,errorFunc) {
      axios.get('/workdoc/car_type')
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }

  loadVehicleRegistrationNo(car_registration_no,completeFunc){
    axios.get('/assetwork/autocomplete/vehicle_registration_no?q='+car_registration_no)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })    
  }

  loadAssetWorkInfo(workNo,completeFunc,errorFunc) {
    axios.get('/assetwork/info?wo='+workNo+'&format=json')
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }


  saveAssetWorkInfo(postData,completeFunc,errorFunc) {
    console.log('postData',postData)
    axios.post('/assetwork/info',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })  
  }

  saveCarType(postData,completeFunc,errorFunc) {
    console.log('postData',postData)
    axios.post('/workdoc/car_type',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })  
  }

  loadProgramWageItem(pgmId, completeFunc, errorFunc) {
    axios.get('/workdoc/programitem/' + pgmId)
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }

  loadCarCategory(categoryId, completeFunc, errorFunc) {
    axios.get('/workdoc/carcategory/' + categoryId)
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }

  loadCustomerCategory(completeFunc, errorFunc) {
    axios.get('/workdoc/customercategory')
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }

  loadCustomer(customerId,completeFunc,errorFunc){
    axios.get('/workdoc/customer/' + customerId )
      .then(function (response) {
        //console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
       // console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }


  loadCustomerList(categoryId, query, pageNo, completeFunc, errorFunc) {
    let param = ''
    if (typeof query !== 'undefined') {
      param = '?query=' + query
    }
    if (typeof pageNo === 'undefined') {
      pageNo = 0
    }
    if (param !== '') {
      param += '&page=' + pageNo
    } else {
      param += '?page=' + pageNo
    }
    axios.get('/workdoc/customerlist/' + categoryId + param)
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }

  loadCustomerSuggestion(query, completeFunc, errorFunc) {
    
    axios.get('/workdoc/customersuggestion/?format=json&q='  + query)
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }

  loadInsurerList(query, start, length, completeFunc, errorFunc) {
    axios.get('/workdoc/insurerlist/?format=json&q=' + query + '&start=' + start + '&length=' + length)
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }

  

  loadInsurerSuggestion(query,  completeFunc, errorFunc) {
    axios.get('/workdoc/insurersuggestion/?format=json&q=' + query )
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }



  loadWorkdocFixingList(workNo, completeFunc, errorFunc) {
    //console.log('loadSlipInfo',slipId)
    axios.get('/workdoc/fixinglist?wo=' + workNo)
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }

  loadWorkdocOfficeTaskList(workNo, completeFunc, errorFunc) {
    axios.get('/workdoc/officetasklist?wo=' + workNo)
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }

  loadWorkdocFixingTaskList(workNo, completeFunc, errorFunc) {
    axios.get('/workdoc/fixingtasklist?wo=' + workNo)
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }

  loadWorkdocFixingPlanList2(completeFunc) {
    return new Promise((resolve, reject) => {
      axios.get('/workdoc/fixingplanlist')
        .then(function (response) {
          console.log(response)
          completeFunc(response.data)
          // resolve(response.data)
        })
        .catch(function (error) {
          console.log(error);
          reject(error);
        })
    })
  }

  loadWorkdocFixingPlanList2ByContractorId(ct_id) {
    return new Promise((resolve, reject) => {
      axios.get('/workdoc/fixingplanlist?ct=' + ct_id)
        .then(function (response) {
          console.log(response)
          resolve(response.data)
        })
        .catch(function (error) {
          console.log(error);
          reject(error);
        })
    })
  }

  loadWorkdocFixingPlanList2ByEmployeeId(em_id) {
    return new Promise((resolve, reject) => {
      axios.get('/workdoc/fixingplanlist?em=' + em_id)
        .then(function (response) {
          console.log(response)
          resolve(response.data)
        })
        .catch(function (error) {
          console.log(error);
          reject(error);
        })
    })
  }

  loadWorkdocFixingPlanListByContractorId(ct_id, completeFunc, errorFunc) {
    axios.get('/workdoc/fixingplanlist?ct=' + ct_id)
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }

  loadWorkdocFixingPlanListByEmployeeId(em_id, completeFunc, errorFunc) {
    axios.get('/workdoc/fixingplanlist?em=' + em_id)
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }

  /* loadWorkdocFixingPlanListByEmployeeId(em_id) {
    return new Promise((resolve, reject) => {
      axios.get('/workdoc/fixingplanlist')
        .then(function (response) {
          console.log(response)
          resolve(response.data)
        })
        .catch(function (error) {
          console.log(error);
          reject(error);
        })
    })
  } */

  loadWorkdocFixingPlanList() {
    return new Promise((resolve, reject) => {
      axios.get('/workdoc/fixingplanlist')
        .then(function (response) {
          console.log(response)
          resolve(response.data)
        })
        .catch(function (error) {
          console.log(error);
          reject(error);
        })
    })
  }

  loadWorkdocFixingListWithTask(workNo, completeFunc, errorFunc) {
    //console.log('loadSlipInfo',slipId)
    axios.get('/workdoc/fixinglist?wo=' + workNo + '&withtask=true')
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }

  loadWorkdocPriceCompare(workNo, completeFunc, errorFunc) {
    //console.log('loadSlipInfo',slipId)
    axios.get('/workdoc/pricecompare?wo=' + workNo)
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        errorFunc(error)
      })
  }

  loadWorkdocPurchaseOrder(workNo, completeFunc, errorFunc) {
    //console.log('loadSlipInfo',slipId)
    axios.get('/workdoc/purchaseorder?wo=' + workNo)
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        errorFunc(error)
      })
  }

  loadWorkdocFixingListHtmlContent(workNo, completeFunc, errorFunc) {
    //console.log('loadSlipInfo',slipId)
    axios.get('/workdoc/fixinglist?wo=' + workNo + '&content=html')
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }

  loadWorkdocFixingOrderList(workNo, completeFunc, errorFunc) {
    //console.log('loadSlipInfo',slipId)
    axios.get('/workdoc/fixing_order_list?wo=' + workNo )
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }

  loadWorkdocFixingOrder(workNo,technician, completeFunc, errorFunc) {
    //console.log('loadSlipInfo',slipId)
    let param = (technician.employee_id!==undefined)?'&employee_id='+technician.employee_id:""
    param += (technician.contractor_id!==undefined)?'&contractor_id='+technician.contractor_id:""
    if(param==="")
      return;
    axios.get('/workdoc/fixing_order?wo=' + workNo +param)
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }

  loadPurchaseSupplier(workNo, shop_id, completeFunc, errorFunc) {
    //console.log('loadSlipInfo',slipId)
    axios.get('/workdoc/purchasesupplier?wo=' + workNo + '&shop_id=' + shop_id)
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }

  loadWorkdocAutocompleteOfficer(completeFunc) {
    //console.log('loadSlipInfo',slipId)
    axios.get('/workdoc/autocomplete/officer?q=&term=')
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
      })
  }

  loadWorkdocAutocompleteStockApprover(completeFunc) {
    //console.log('loadSlipInfo',slipId)
    axios.get('/workdoc/autocomplete/stockapprover?q=&term=')
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
      })
  }

  loadWorkdocAutocompleteWorkNo(query,completeFunc) {
    //console.log('loadSlipInfo',slipId)
    axios.get('/workdoc/autocomplete/work_no?q='+query)
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
      })
  }

  loadAttachment(wo, completeFunc) {
    axios.get('/workdoc/attachment?wo=' + wo + '&format=json')
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
      })
  }

  loadFup(wo, cat, completeFunc) {
    axios.get('/workdoc/images/' + cat + '?wo=' + wo)
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
      })
  }

  loadImagesLeftPrint(wo, cat, completeFunc) {
    axios.get('/workdoc/images_left_print/' + cat + '?wo=' + wo + '&cat=' + cat)
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
      })
  }

  loadTimeline(wo, completeFunc) {
    axios.get('/workdoc/timeline?wo=' + wo + '&new_work=false&format=json')
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
      })
  }

  loadWorkdocMessages(wo, completeFunc,errorFunc) {
    axios.get('/workdoc/messages?wo=' + wo + '&format=json')
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        errorFunc(error)
      })
  }

  loadManageuser(completeFunc) {
    axios.get('/admin/manageuser?format=json')
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
      })
  }

  loadWagelist(wo, completeFunc) {
    axios.get('/workdoc/wagelist?wo='+wo+'&format=json')
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
      })
  }

  loadCarRegistrationNo(car_registration_no,completeFunc){
    axios.get('/workdoc/autocomplete/car_registration_no?q='+car_registration_no)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })    
  }

  loadCarRegistrationNoWithWork(car_registration_no,completeFunc){
    axios.get('/workdoc/autocomplete/car_registration_no?q='+car_registration_no+'&withwork=true')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })    
  }

  loadTimerecord(workdoc, completeFunc, errorFunc) {
    axios.get('/workdoc/timerecord?wo=' + workdoc)
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }

  loadMechanicWaitPart(completeFunc, errorFunc) {
    axios.get('/workdoc/mechanicwaitpart')
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }  

  loadCreditInstallation(workNo,completeFunc){
    axios.get('/workdoc/related_doc?wo='+workNo+'&dn=creditinstallation&format=json')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  saveCustomer(postData, completeFunc, errorFunc) {

    console.log('postData', postData)
    axios.post('/workdoc/customer/', postData)
      .then(function (response) {
        //console.log(response.data)
        let result = response.data
        if (result.status==='OK')
          completeFunc(result)
        else
          errorFunc(result)
      })
      .catch(function (error) {
        //console.log(error);
        errorFunc({ status: 'error', desc: error });
      })
  }

  saveCarCategory(catId, catName, completeFunc, errorFunc) {
    let postData = { cat_id: catId, cat_name: catName }
    console.log('postData', postData)
    axios.post('/workdoc/carcategory/' + catId, querystring.stringify(postData))
      .then(function (response) {
        console.log(response.data)
        let result = response.data
        if (result.status==='OK')
          completeFunc(result)
        else
          errorFunc(result)
      })
      .catch(function (error) {
        console.log(error);
        errorFunc({ status: 'error', desc: error });
      })
  }

  saveStockPartCategory(catId, catName, completeFunc, errorFunc) {
    let postData = { cat_id: catId, cat_name: catName }
    console.log('postData', postData)
    axios.post('/stock/newcategory/GENPART', querystring.stringify(postData))
      .then(function (response) {
        console.log(response.data)
        let result = response.data
        if (result.status==='OK')
          completeFunc(result)
        else
          errorFunc(result)
      })
      .catch(function (error) {
        console.log(error);
        errorFunc({ status: 'error', desc: error });
      })
  }

  saveWorkdocFixingList(workNo,wageList,partList,program,discountPart,discountWage,completeFunc,errorFunc) {

    let postData = { wo: workNo, wage_list: wageList, part_list: partList, program: program }
    console.log('postData', postData)
    axios.post('/workdoc/fixinglist', postData)
      .then(function (response) {
        console.log(response.data)
        let result = response.data
        if (result.status==='OK')
          completeFunc(result)
        else
          errorFunc(result)
      })
      .catch(function (error) {
        console.log(error);
        errorFunc({ status: 'error', desc: error });
      })
  }

  saveWorkdocFixingList2(postData,completeFunc,errorFunc) {

    //let postData = { wo: workNo, wage_list: wageList, part_list: partList, program: program,discount_wage:discountWage,discount_part:discountPart }
    console.log('postData', postData)
    axios.post('/workdoc/fixinglist', postData)
      .then(function (response) {
        console.log(response.data)
        let result = response.data
        if (result.status==='OK')
          completeFunc(result)
        else
          errorFunc(result)
      })
      .catch(function (error) {
        console.log(error);
        errorFunc({ status: 'error', desc: error });
      })
  }

  saveWorkdocOfficeTask(taskId, postData, completeFunc, errorFunc) {
    console.log('officetask', taskId, postData)
    axios.post('/workdoc/officetask/' + taskId, postData)
      .then(function (response) {
        console.log(response.data)
        let result = response.data
        if (result.status==='OK')
          completeFunc(result)
        else
          errorFunc(result)
      })
      .catch(function (error) {
        console.log(error);
        errorFunc({ status: 'error', desc: error });
      })
  }

  saveWorkdocFixingTask(taskId, postData, completeFunc, errorFunc) {
    console.log('fixingtask', taskId, postData)
    axios.post('/workdoc/fixingtask/' + taskId, postData)
      .then(function (response) {
        console.log(response.data)
        let result = response.data
        if (result.status==='OK')
          completeFunc(result)
        else
          errorFunc(result)
      })
      .catch(function (error) {
        console.log(error);
        errorFunc({ status: 'error', desc: error });
      })
  }

  saveWorkdocSummary(postData, completeFunc, errorFunc) {

    axios.post('/workdoc/summary', postData)
      .then(function (response) {
        console.log(response.data)
        let result = response.data
        if (result.status==='OK')
          completeFunc(result)
        else
          errorFunc(result)
      })
      .catch(function (error) {
        console.log(error);
        errorFunc({ status: 'error', desc: error });
      })
  }

  savePriceCompmare(workNo, postData, completeFunc, errorFunc) {
    console.log('pricecompare', workNo, postData)
    postData['wo'] = workNo
    axios.post('/workdoc/pricecompare/', postData)
      .then(function (response) {
        console.log(response.data)
        let result = response.data
        if (result.status==='OK')
          completeFunc(result)
        else
          errorFunc(result)
      })
      .catch(function (error) {
        console.log(error);
        errorFunc({ status: 'error', desc: error });
      })
  }

  saveWorkdocRelated(workNo,docName,detail,completeFunc,errorFunc){
    let postData = {work_no:workNo,doc_name:docName,detail:detail}
    console.log('postData',postData)
    axios.post('/workdoc/related_doc/', postData)
      .then(function (response) {
        console.log(response.data)
        let result = response.data
        if (result.status==='OK')
          completeFunc(result)
        else
          errorFunc(result)
      })
      .catch(function (error) {
        console.log(error);
        errorFunc({ status: 'error', desc: error });
      })
  }

  saveAssetWorkRelated(workNo,docName,detail,completeFunc,errorFunc){
    let postData = {work_no:workNo,doc_name:docName,detail:detail}
    console.log('postData=>',postData)
    axios.post('/assetwork/related_doc/', postData)
      .then(function (response) {
        console.log(response.data)
        let result = response.data
        if (result.status==='OK')
          completeFunc(result)
        else
          errorFunc(result)
      })
      .catch(function (error) {
        console.log(error);
        errorFunc({ status: 'error', desc: error });
      })
  }

  loadWorkdocRelated(workNo,docName,completeFunc,errorFunc) {
    axios.get('/workdoc/related_doc?wo=' + workNo + '&dn='+ docName + '&format=json')
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        errorFunc(error)
      })
  }

  loadAssetWorkRelated(workNo,docName,completeFunc,errorFunc) {
    axios.get('/assetwork/related_doc?wo=' + workNo + '&dn='+ docName + '&format=json')
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        errorFunc(error)
      })
  }

  loadPartListPhotoBook(workNo,completeFunc,errorFunc) {
    axios.get('/workdoc/partlistphotobook?cat=hino&dn=kkc_photobook_doc&wo='+workNo+'&format=json')
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        errorFunc(error)
      })
  }

  saveWorkdocFixingOrder(meta,person,items,completeFunc,errorFunc){
    let postData = {meta:meta,person:person,items:items}
    axios.post('/workdoc/fixing_order/'+meta.work_no, postData)
      .then(function (response) {
        console.log(response.data)
        let result = response.data
        if (result.status==='OK')
          completeFunc(result)
        else
          errorFunc(result)
      })
      .catch(function (error) {
        console.log(error);
        errorFunc({ status: 'error', desc: error });
      })
  }

  saveWorkdocPurchase(workNo,items,completeFunc,errorFunc){
    let postData = {work_no:workNo,items:items}
    axios.post('/workdoc/purchaseorder/'+workNo, postData)
      .then(function (response) {
        console.log(response.data)
        let result = response.data
        if (result.status==='OK')
          completeFunc(result)
        else
          errorFunc(result)
      })
      .catch(function (error) {
        console.log('error',error);
        errorFunc({ status: 'error', desc: error });
      })
  }

  saveWorkdocPhotoPrint(postData,completeFunc,errorFunc){
    
    axios.post('/workdoc/images_print/'+postData.cat_id, postData)
      .then(function (response) {
        console.log(response.data)
        let result = response.data
        if (result.status==='OK')
          completeFunc(result)
        else
          errorFunc(result)
      })
      .catch(function (error) {
        console.log(error);
        errorFunc({ status: 'error', desc: error });
      })
  }

  saveWorkdocDamage(postData, completeFunc, errorFunc) {

    axios.post(`/workdoc/damage?wo=${postData.wo}`,
        qs.stringify(postData),
    ).then(function(response) {
      console.log(response.data);
      let result = response.data;
      if (result.status==='OK')
        completeFunc(result);
      else
        errorFunc(result);
    }).catch(function(error) {
      console.log(error);
      errorFunc({status: 'error', desc: error});
    });
  }

  saveWorkdocDamage2(postData, completeFunc, errorFunc) {

    axios.post(`/workdoc/damage_v2?wo=${postData.wo}`,
        postData,
    ).then(function(response) {
      console.log(response.data);
      let result = response.data;
      if (result.status==='OK')
        completeFunc(result);
      else
        errorFunc(result);
    }).catch(function(error) {
      console.log(error);
      errorFunc({status: 'error', desc: error});
    });
  }

  // saveWorkdocDamage2(postData, completeFunc, errorFunc) {

  //   axios.post(`/workdoc/damage_v2?wo=${postData.wo}`, postData)
  //       .then(function(response) {
  //         console.log(response.data);
  //         let result = response.data;
  //         if (result.status==='OK')
  //           completeFunc(result);
  //         else
  //           errorFunc(result);
  //       })
  //       .catch(function(error) {
  //         console.log(error);
  //         errorFunc({status: 'error', desc: error});
  //       });
  // }

  saveCarColor(postData,completeFunc,errorFunc){
    
    axios.post('/workdoc/car_color/', postData)
      .then(function (response) {
        console.log(response.data)
        let result = response.data
        if (result.status==='OK')
          completeFunc(result)
        else
          errorFunc(result)
      })
      .catch(function (error) {
        console.log('error',error);
        errorFunc({ status: 'error', desc: error });
      })
  }

  saveMechanicWaitPart(postData,completeFunc,errorFunc){
    //postData = {time_id:'',status:'1'} 1=approve,2=notapprove
    axios.post('/workdoc/mechanicwaitpart/', postData)
      .then(function (response) {
        console.log(response.data)
        let result = response.data
        if (result.status==='OK')
          completeFunc(result)
        else
          errorFunc(result)
      })
      .catch(function (error) {
        console.log('error',error);
        errorFunc({ status: 'error', desc: error });
      })
  }

 

  delCustomer(customerId, completeFunc, errorFunc) {

    console.log('customerId', customerId)
    axios.delete('/workdoc/customer/' + customerId)
      .then(function (response) {
        console.log(response.data)
        let result = response.data
        if (result.status==='OK')
          completeFunc(result)
        else
          errorFunc(result)
      })
      .catch(function (error) {
        console.log(error);
        errorFunc({ status: 'error', desc: error });
      })
  }



  delCarCategory(catId, completeFunc, errorFunc) {

    axios.delete('/workdoc/carcategory/' + catId)
      .then(function (response) {
        console.log(response.data)
        let result = response.data
        if (result.status==='OK')
          completeFunc(result)
        else
          errorFunc(result)
      })
      .catch(function (error) {
        console.log(error);
        errorFunc({ status: 'error', desc: error });
      })
  }

  delWorkdocFixingTask(taskId, completeFunc, errorFunc) {

    axios.delete('/workdoc/fixingtask/' + taskId)
      .then(function (response) {
        console.log(response.data)
        let result = response.data
        if (result.status==='OK')
          completeFunc(result)
        else
          errorFunc(result)
      })
      .catch(function (error) {
        console.log(error);
        errorFunc({ status: 'error', desc: error });
      })
  }

  loadPayment(iv,docType,completeFunc,errorFunc) {
    axios.get('/'+docType+'/payment_detail?iv='+iv)
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }

  loadWorkDocStock(workNo,completeFunc,errorFunc) {
    axios.get('/workdoc/stock?wo='+workNo+'&format=json')
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }

  savePayment(postData,iv,docType,completeFunc,errorFunc) {
    axios.post('/'+docType+'/payment_detail?iv='+iv+'/', postData)
      .then(function (response) {
        console.log(response.data)
        let result = response.data
        if (result.status==='OK')
          completeFunc(result)
        else
          errorFunc(result)
      })
      .catch(function (error) {
        console.log(error);
        errorFunc({ status: 'error', desc: error });
      })
  }

  cancelPayment(postData,iv,docType,completeFunc,errorFunc) {
    axios.post('/'+docType+'/cancel?iv='+iv, postData)
      .then(function (response) {
        console.log(response.data)
        let result = response.data
        if (result.status==='OK')
          completeFunc(result)
        else
          errorFunc(result)
      })
      .catch(function (error) {
        console.log(error);
        errorFunc({ status: 'error', desc: error });
      })
  }

  saveRemarkRecord(postData,completeFunc,errorFunc) {
    console.log('postData',postData)
    axios.post('/audit/remarkrecord',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })  
  }

  saveAttachmentTransfer(postData,completeFunc,errorFunc) {
    // console.log('postData',postData)
    axios.post('/workdoc/attachment_transfer',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })  
  }

  saveAttachmentCopy(postData,completeFunc,errorFunc) {
    // console.log('postData',postData)
    axios.post('/workdoc/attachment_copy',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })  
  }

  saveWorkdocMessages(postData,completeFunc,errorFunc) {
    // console.log('postData',postData)
    axios.post('/workdoc/messages',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })  
  }

  saveInfoAccidentType(postData,completeFunc,errorFunc) {
    console.log('postData',postData)
    axios.post('/workdoc/info_accident_type/',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })  
  }

  saveInfoExcess(postData,completeFunc,errorFunc){
    
    console.log('postData',postData)
    axios.post('/workdoc/info_excess',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  saveInsurer(insurer_id,postData,completeFunc,errorFunc){
    console.log('postData',postData)
    axios.post('/workdoc/insuerer/'+insurer_id, postData)
      .then(function (response) {
        console.log(response.data)
        let result = response.data
        if (result.status==='OK')
          completeFunc(result)
        else
          errorFunc(result)
      })
      .catch(function (error) {
        console.log('error',error);
        errorFunc({ status: 'error', desc: error });
      })
  }

  loadAffialiateList(completeFunc,errorFunc) {
    axios.get('/workdoc/autocomplete/affiliateslist')
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }

  loadAutoAffialiateList(aff,completeFunc,errorFunc) {
    axios.get('/workdoc/autocomplete/affiliateslist?q='+aff)
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }

  saveAffiliate(postData,completeFunc,errorFunc){
    console.log('postData',postData)
    axios.post('/workdoc/affiliates/'+postData.affiliates_id,postData)
      .then(function (response) {
        console.log(response.data)
        let result = response.data
        if (result.status==='OK')
          completeFunc(result)
        else
          errorFunc(result)
      })
      .catch(function (error) {
        console.log('error',error);
        errorFunc({ status: 'error', desc: error });
      })
  }

  updateCreateJobStatus(workNo,status,completeFunc,errorFunc){
    let postData = {wo:workNo,status:status}
    axios.post('/work/create_job_status/?wo='+workNo+'&status='+status,postData)
      .then(function (response) {
        //console.log(response.data)
        let result = response.data
        if (result.status==='OK')
          completeFunc(result)
        else
          errorFunc(result)
      })
      .catch(function (error) {
        console.log('error',error);
        errorFunc({ status: 'error', desc: error });
      })
  }

  delImg(delUrl, completeFunc, errorFunc) {

    axios.delete(delUrl)
      .then(function (response) {
        console.log(response.data)
        let result = response.data
        if (result.status==='OK')
          completeFunc(result)
        else
          errorFunc(result)
      })
      .catch(function (error) {
        console.log(error);
        errorFunc({ status: 'error', desc: error });
      })
  }

  postDelImg(delUrl, completeFunc, errorFunc) {

    axios.post(delUrl)
      .then(function (response) {
        console.log(response.data)
        let result = response.data
        if (result.status==='OK')
          completeFunc(result)
        else
          errorFunc(result)
      })
      .catch(function (error) {
        console.log(error);
        errorFunc({ status: 'error', desc: error });
      })
  }

  sendSMS(postData,completeFunc,errorFunc) {        
    axios.post('/notification/send_sms/'+postData.mobile_no, postData)
      .then(function (response) {
        console.log(response.data)
        let result = response.data
        if (result.status==='OK')
          completeFunc(result)
        else
          errorFunc(result)
      })
      .catch(function (error) {
        console.log(error);
        errorFunc({ status: 'error', desc: error });
      })
  }

  delSms(bfId,completeFunc,errorFunc){
    
    axios.delete('/workdoc/notification_sms/'+bfId)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  loadInsuranceOption(docType,viewMode,year,month,day,completeFunc,errorFunc) {
    year = year - 543
    axios.get('/'+docType+'/insurancelist/'+viewMode+'?year='+year+'&month='+month+'&day='+day)
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }

  workPhotoThumb(postData,completeFunc,errorFunc) {        
    axios.post('/workdoc/work_photo_thumb/', postData)
      .then(function (response) {
        console.log(response.data)
        let result = response.data
        if (result.status==='OK')
          completeFunc(result)
        else
          errorFunc(result)
      })
      .catch(function (error) {
        console.log(error);
        errorFunc({ status: 'error', desc: error });
      })
  }

  loadShopList(query,completeFunc,errorFunc) {
    axios.get('/workdoc/autocomplete/shoplist?q='+query+'&term=')
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }

  loadFixlevelConfig(completeFunc,errorFunc) {
    axios.get('/workdoc/fixlevelconfig')
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }

  saveFixlevelConfig(postData,completeFunc,errorFunc) {
    // console.log('postData',postData)
    axios.post('/workdoc/fixlevelconfig',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })  
  }

  loadAppointmentRecord(wo,completeFunc,errorFunc) {
    axios.get('/workdoc/appointmentrecord?wo='+wo)
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }

  saveAppointmentRecord(postData,completeFunc,errorFunc) {
    axios.post('/workdoc/appointmentrecord',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })  
  }

  downloadAttachment(workNo,category,postData,completeFunc,errorFunc){
    axios.post('/media/attachment_download/workdoc?wo='+workNo+'&cat='+category, postData,{responseType: 'blob'})
     .then((response) => {
      console.log('response',response.headers);      
      completeFunc(response)
    }).catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })  
  }

  saveInfoDelivering(postData,completeFunc,errorFunc) {
    console.log('postData',postData)
    axios.post('/workdoc/info_delivering',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })  
  }  

  loadLatestQuotationPart(wo,completeFunc, errorFunc) {
    axios.get('/quotation/latest_quotation_part?wo='+wo)
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }

  loadConfigAttachment(completeFunc, errorFunc) {
    axios.get('/workdoc/config_attachment')
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }

  loadCreditNoteReason(completeFunc, errorFunc) {
    axios.get('/workdoc/autocomplete/creditnote_reason')
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }

  saveConfigAttachment(postData,completeFunc,errorFunc) {
    console.log('postData',postData)
    axios.post('/workdoc/config_attachment',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })  
  }

  loadTaxinvoiceDoc(tiv, completeFunc, errorFunc) {
    axios.get('/taxinvoice/doc/?format=json&tiv='+tiv)
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }

  loadBankList(completeFunc, errorFunc) {
    axios.get('/workdoc/banklist')
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }

  loadAccountInfo(wo, type, completeFunc, errorFunc) {
    axios.get('/workdoc/account_info/?wo='+wo+'&account_type='+type)
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }

  loadShopCategoryList(completeFunc, errorFunc) {
    axios.get('/workdoc/autocomplete/shop_category')
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }

  loadPartOutstandingRecord(recordType, workNo, completeFunc, errorFunc) {
    axios.get('/workdoc/part_outstanding_record?wo='+workNo+'&type='+recordType)
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }

  savePartRecord(postData,completeFunc,errorFunc) {
    console.log('postData',postData)
    axios.post('/workdoc/part_record',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.result==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })  
  }

  loadSimilarWork(wo,completeFunc, errorFunc) {
    axios.get('/workdoc/similar_work/?wo='+wo)
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }

  loadFixinglistWithstock(wo,completeFunc, errorFunc) {
    axios.get('/workdoc/fixinglist_withstock/?wo='+wo)
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }

  loadPartReception(wo,completeFunc, errorFunc) {
    axios.get('/workdoc/part_reception?wo='+wo)
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }

  saveAttachmentCopyToPo(postData,completeFunc,errorFunc) {
    console.log('postData',postData)
    axios.post('/workdoc/attachment_copy_to_po',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })  
  }

  loadInvoicedocDetail(wo,invoiceType,qoNo,completeFunc, errorFunc) {
    axios.get('/workdoc/invoicedoc_detail?wo='+wo+"&invoice_type="+invoiceType+"&qo="+qoNo)
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }

  loadImagesPrintHistory(cat,wo,completeFunc, errorFunc) {
    axios.get('/workdoc/images_print_history/'+cat+'?wo='+wo)
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }

  loadImagesPrint(cat,history,wo,completeFunc, errorFunc) {
    axios.get('/workdoc/images_print/'+cat+'/'+history+'?wo='+wo)
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }

  loadPMTasklist(wo,completeFunc, errorFunc) {
    axios.get('/workdoc/pmtasklist?wo='+wo)
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }

  loadConfigWork(completeFunc, errorFunc) {
    axios.get('/workdoc/config_work')
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }

  saveConfigWork(postData,completeFunc,errorFunc) {
    console.log('postData',postData)
    axios.post('/workdoc/config_work',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })  
  }

  loadConfigCheckcar(car_type,completeFunc,errorFunc){
    let url = '/workdoc/config_checkcar'
    if (car_type!=='')
      url = '/workdoc/config_checkcar/'+car_type
    axios.get(url)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc(error)
    })
  }

  loadWorkDocImgBody(wo,completeFunc,errorFunc){
    axios.get('/workdoc/img_body?wo='+wo)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc(error)
    })
  }

  saveConfigCheckcar(postData,completeFunc,errorFunc){
    
    console.log('postData',postData)
    axios.post('/workdoc/config_checkcar',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  loadWageMasterData(completeFunc){
    axios.get('/damage/wage_masterdata')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  saveWageMasterData(postData,completeFunc,errorFunc){
    console.log('postData',postData)
    axios.post('/damage/wage_masterdata',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  loadCustomerMasterData(completeFunc){
    axios.get('/workdoc/customer_masterdata')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  saveCustomerMasterData(postData,completeFunc,errorFunc){
    console.log('postData',postData)
    axios.post('/workdoc/customer_masterdata',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  loadWageCategory(completeFunc,errorFunc) {
    axios.get('/damage/wagecategory')
    .then(function (response) {
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
      if (errorFunc !== undefined)
        errorFunc(error)
    })
  }

  saveWageCategory(postData,completeFunc,errorFunc) {
    console.log('postData',postData)
    axios.post('/damage/wagecategory',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })  
  }

  delWageCategory(id,completeFunc,errorFunc){
    
    console.log('id',id)
    axios.delete('/damage/wagecategory/'+id)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  loadWageCategory(completeFunc,errorFunc) {
    axios.get('/damage/wagecategory')
    .then(function (response) {
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
      if (errorFunc !== undefined)
        errorFunc(error)
    })
  }

  loadSymptom(wo,completeFunc,errorFunc) {
    axios.get('/workdoc/symptom?wo='+wo)
    .then(function (response) {
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
      if (errorFunc !== undefined)
        errorFunc(error)
    })
  }

  savePMTasklist(postData,completeFunc,errorFunc) {
    console.log('postData',postData)
    axios.post('/workdoc/pmtasklist',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })  
  }
  
  savePMFixingTask(task_id,postData,completeFunc,errorFunc) {
    console.log('postData',postData)
    axios.post('/workdoc/pmfixingtask'+(task_id!==''?'/'+task_id:''),postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })  
  }

  delPMFixingTask(task_id,completeFunc,errorFunc){
    axios.delete('/workdoc/pmfixingtask/'+task_id)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  saveJobControlBoardSeq(postData,control,completeFunc,errorFunc) {
    // console.log('postData',postData)
    let path = 'jobcontrolboard_seq'
    if (control==='workJobOffice')
      path = 'officecontrolboard_seq'
    axios.post('/workdoc/'+path,postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })  
  }

  saveReportCustomCost(postData,completeFunc,errorFunc) {
    console.log('postData',postData)
    axios.post('/workdoc/report_custom_cost',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })  
  }

  saveJobcontrolboardOrderBy(postData,completeFunc,errorFunc) {
    console.log('postData',postData)
    axios.post('/workdoc/jobcontrolboard_order_by',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })  
  }

}

export default new WorkdocStore()



// WEBPACK FOOTER //
// ./src/stores/WorkdocStore.js